// extracted by mini-css-extract-plugin
module.exports = {"container":"Write_container__36E1x","itemA":"Write_itemA__1Eue7","itemB":"Write_itemB__27Cn-","itemC":"Write_itemC__XUmlf","itemD":"Write_itemD__3BAzu"};